@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.balance

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.ridepayment.ExtendedRidePaymentDto


object GetPassengerTransactionsHistoryEndpoint :
    EndPoint<GetPassengerTransactionsHistoryEndpoint.Request, GetPassengerTransactionsHistoryEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val versionCode: String?,
    )

    class Response(
        val paymentsList: Array<ExtendedRidePaymentDto>,
        val total: Int,
    )
}